export const IMAGE_API_URL = 'https://api.unsplash.com/search/photos';

export const IMAGE_API_KEY = 'S4g2XgVyKGJ9eQ1GRU5sHb4bsBUrk3Gp_feeTowhWX0';